export const SMART_APPOINTMENT = {
  ID: 'smartAppointment',
  TITLE: 'Fecha de instalación',
  TITLE_MANUAL_APPOINTMENT: 'Instalación del servicio',
  CALENDAR: {
    NAME: 'calendar',
    ID: 'calendar',
    LABEL:
      'Un técnico acudirá en la franja horaria indicada para iniciar la instalación.',
  },
  SKIP_SMART_APPOINTMENT: {
    NAME: 'skip-smart-Appointment',
    ID: 'skip-smart-Appointment',
    LABEL:
      'Prefiero que me llameis en los proximos días para concretar la cita',
    RULES: {},
  },
};
